import type { ReactNode } from 'react';

import type { LANGUAGE } from '@/types/commonConst';

import { getFeatureMessage } from '..';
import { commonMessages } from './messages';

export type CommonMessageKey = keyof typeof commonMessages;

export const getCommonMessage = (
  lang: LANGUAGE,
  key: CommonMessageKey,
): ReactNode => {
  return getFeatureMessage(commonMessages[key], lang);
};
